import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ListaContatosModel} from '../../../../shared/model/disparo-automatico/lista-contatos.model';
import {ButtonPadraoComponent} from '../../../../shared/components/button-padrao/button-padrao.component';
import {CelularMaskPipe} from '../../../../shared/pipe/celular-mask.pipe';
import {MatIcon} from '@angular/material/icon';
import { MethodsUtils } from '../../../../shared/util/methods.utils';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-modal-lista-contatos',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    CelularMaskPipe,
    MatIcon,
    MatTooltip
  ],
  templateUrl: './modal-lista-contatos.component.html',
  styleUrl: './modal-lista-contatos.component.css'
})
export class ModalListaContatosComponent implements OnInit {
  anexo: any;
  listaContatos: ListaContatosModel[] = [];

  private readonly dialogRef = inject(MatDialogRef<ModalListaContatosComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.anexo = this.data.anexo;
    this.manipularInformacoesAnexo();
  }

  manipularInformacoesAnexo(){
    this.listaContatos = this.anexo.listaContatos;

    this.listaContatos.forEach(contato => {
      contato.isContatoValido = this.validarTelefone(contato.telefone!);
      contato.isEmailValido = this.validarEmail(contato.email!);
    });
  }

  validarTelefone(telefone: string): boolean {
    const telefoneNumerico = telefone.replace(/\D/g, '');
    if (telefoneNumerico.length >= 12 && telefoneNumerico.length <= 13) {
      return true;
    }
    return false;
  }

  validarEmail(email: string): boolean {
    const emailTrimmed = email.trim().toLowerCase();
    return emailTrimmed.includes('@') && emailTrimmed.includes('.com');
  }

  sair() { this.dialogRef.close(); }

  verificarFotoContato(contatoSelecionado: ListaContatosModel): string {
    return MethodsUtils.informacoesPorStatusContato(contatoSelecionado.statusContato, true);
  }

  toolTipFotoContato(contatoSelecionado: ListaContatosModel): string {
    return MethodsUtils.informacoesPorStatusContato(contatoSelecionado.statusContato, false);
  }



}
